export default "__VITE_ASSET__BmnF9dfT__"